export default "<div style=\"text-align:center\">\n  Copyright Daifuku Mechatroncis Singapore\n</div>\n"